import { useRef, useState, useEffect } from "react";
import styles from "./truncated-box.module.scss";

export function TruncatedBox(props: { text: string | JSX.Element, listKey: string, reconsider?: boolean }): JSX.Element {
    const inputType = typeof props.text;

    const containerRef = useRef<HTMLDivElement>(null);
    const textElementRef = useRef<HTMLParagraphElement>(null);

    const [ enableTruncating, setEnableTruncating ] = useState<boolean>(true);

    useEffect(() => {
        setEnableTruncating(true);
    }, [props.reconsider])

    useEffect(() => {
        handle();
    }, [enableTruncating]);

    const handle = (): void => {
        const containerElement = containerRef?.current;
        const textElement = textElementRef?.current;
    
        if (!textElement || !containerElement) return;
    
        if (textElement.scrollHeight <= textElement.clientHeight) {
            setEnableTruncating(false);
            console.log(`Disabled truncating as height is ${textElement.clientHeight} (id: ${props.listKey})`)
        }
    }

    return (
        <>
            { inputType !== 'string' && props.text }
            { inputType === 'string' && (
                <div className={`${styles.truncated_box} ${enableTruncating ? '' : styles.disable_truncating}`} ref={containerRef}>
                    <input type="checkbox" id={`expanded-${props.listKey}`}></input>
                    <p ref={textElementRef}>{props.text}</p>
                    <label htmlFor={`expanded-${props.listKey}`} role="button"><span></span></label>
                </div>
            ) }
        </>
    )
}